import { DeleteOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';

import type { SalaryFormat } from '@app/api/ClientServices';
import { DurationSelects } from '@app/components';
import {
  U_ACTION,
  U_CATEGORY,
  U_DURATION,
  U_KEY,
  U_NAME,
  U_SALARY,
} from '@app/constants';
import { ServiceSalaryComponent } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components';
import { ArchiveLabel } from '@app/shared/components';
import type { NEmployees } from '@app/types/Employees';

const { Text } = Typography;

export const adaptDataToTable = (
  data: NEmployees.ModelClientService[],
  deleteCategory: (id: number, duration: number) => void,
  onHourSelect: (value: number, id?: number) => void,
  onMinuteSelect: (value: number, id?: number) => void,
  hasUserRightToDeleteService: boolean,
  onSalaryTypeSelect: (value: SalaryFormat, id?: number) => void,
  onSalaryValueChange: (value: string, id?: number) => void
) => {
  return data.map((service: NEmployees.ModelClientService) => {
    const {
      Id,
      Category,
      Name,
      PriceS,
      PriceE,
      Duration,
      SalaryAmount,
      SalaryFormat,
    } = service;
    const transformTime = (minutes: number) => {
      const hours = Math.floor(minutes / 60);
      const minutesFormatted = (minutes % 60).toString().padStart(2, '0');
      return {
        hours,
        minutes: Number(minutesFormatted),
      };
    };

    return {
      [U_KEY]: String(Id),
      [U_CATEGORY]: (
        <div data-testid="category-name">
          <Text type="secondary" style={{ marginBottom: '4px' }}>
            {Category}
          </Text>
          {service?.IsDeleted && <ArchiveLabel />}
        </div>
      ),
      [U_NAME]: (
        <div>
          <Text data-testid="service-name">{Name}</Text> <br />
          <div data-testid="service-price">
            <Text type="secondary">
              {PriceE && 'от'} {PriceS}
            </Text>
            {PriceE && <Text type="secondary"> до {PriceE}</Text>}
          </div>
        </div>
      ),
      [U_DURATION]: (
        <div className="duration-select-wrapper">
          <DurationSelects
            durationError={''}
            onHourSelect={onHourSelect}
            onMinuteSelect={onMinuteSelect}
            width={100}
            defaultHours={transformTime(Duration).hours}
            defaultMinutes={transformTime(Duration).minutes}
            id={Id}
          />
        </div>
      ),
      [U_SALARY]: (
        <ServiceSalaryComponent
          onSalaryTypeSelect={onSalaryTypeSelect}
          onSalaryValueChange={onSalaryValueChange}
          serviceId={Id}
          defaultSalaryAmount={SalaryAmount}
          defaultSalaryFormat={SalaryFormat}
        />
      ),
      [U_ACTION]: hasUserRightToDeleteService ? (
        <Tooltip title="Удалить услугу">
          <Button
            icon={<DeleteOutlined />}
            onClick={() => deleteCategory(Id, Duration)}
            data-testid="delete-category"
          />
        </Tooltip>
      ) : (
        <></>
      ),
    };
  });
};
